import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/icons/arrow-dots.png")